import { AffiliateAdjustment } from '@core/models/affiiliate-adjustment.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class AffiliateAdjustmentEntityService extends EntityCollectionServiceBase<AffiliateAdjustment> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('AffiliateAdjustment', serviceElementsFactory);
  }
}